import { OAuthStatusResponse } from '@firestore-gui/shared';
import { GcpDatabasePicker } from '../gcp-database-picker';
import { GcpProjectPicker } from '../gcp-project-picker';
import { Spinner } from '../ui';
import { Card, CardContent } from '../ui/card';
import { useGcpConnectionSetup } from './use-gcp-connection-setup';

interface GcpConnectionSetupProps {
  oauthStatus: OAuthStatusResponse | null;
  onConnectionComplete: () => Promise<void>;
}

export function GcpConnectionSetup({ oauthStatus, onConnectionComplete }: GcpConnectionSetupProps) {
  const f = useGcpConnectionSetup({ oauthStatus, onConnectionComplete });

  if (!f.shouldShow) return null;

  if (f.loading) {
    return (
      <div className="flex justify-center">
        <div className="w-full max-w-2xl">
          <Card>
            <CardContent className="p-4">
              <div className="text-sm text-muted-foreground">Loading connection status...</div>
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

  if (f.isConnecting) {
    return (
      <div className="flex justify-center">
        <div className="w-full max-w-2xl">
          <Card>
            <CardContent className="p-4">
              <div className="flex items-center gap-3">
                <Spinner size="md" />
                <div className="text-sm text-muted-foreground">Connecting to Firestore...</div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-center">
      <div className="w-full max-w-2xl space-y-4">
        {!f.selectedProjectId ? (
          <GcpProjectPicker onProjectSelect={f.handleProjectSelect} />
        ) : (
          <GcpDatabasePicker
            projectId={f.selectedProjectId}
            onDatabaseSelect={f.handleDatabaseSelect}
            onBackToProjectSelection={f.handleBackToProjectSelection}
          />
        )}
      </div>
    </div>
  );
}
